import { PAYMENT_TYPES, PaymentType } from './types';

export const isPaymentType = (value: unknown): value is PaymentType =>
  PAYMENT_TYPES.includes(value as PaymentType);
